<div class="d-flex flex-column gap-4">
  <div class="title-md" i18n>About</div>
  <div class="general-details-form-grid" [formGroup]="formGroup">
    <div class="unit-name d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'unitName'" i18n>Unit Name</label>
      <app-text-input
        formControlName="unitName"
        controlId="unitName"
        [error]="formSubmitted && formGroup.controls.unitName.invalid" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.unitName.invalid"
        [customErrorMessages]="customErrorMessages.unitName"
        [errors]="formGroup.controls.unitName.errors" />
    </div>
    <div class="unit-id d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'clientUnitId'" i18n>Unit ID</label>
      <app-numeric-string-input
        formControlName="clientUnitId"
        controlId="clientUnitId"
        [maxLength]="8"
        [error]="formSubmitted && formGroup.controls.clientUnitId.invalid" />
      <div class="form-input-hint" i18n>Numeric only, up to 8 characters</div>
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.clientUnitId.invalid"
        [customErrorMessages]="customErrorMessages.clientUnitId"
        [errors]="formGroup.controls.clientUnitId.errors" />
    </div>
    <div class="d-flex flex-column gap-1">
      <label [for]="'designatedUnitTypeId'" class="form-input-label" i18n>Category</label>
      <app-dropdown-input
        formControlName="designatedUnitTypeId"
        controlId="designatedUnitTypeId"
        [dropdowns]="designatedUnitTypeDropdowns"
        [error]="formSubmitted && formGroup.controls.designatedUnitTypeId.invalid" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.designatedUnitTypeId.invalid"
        [customErrorMessages]="customErrorMessages.designatedUnitTypeId"
        [errors]="formGroup.controls.designatedUnitTypeId.errors" />
    </div>
    <div class="d-flex flex-column gap-1">
      <label [for]="'remittanceFrequencyTypeId'" class="form-input-label" i18n>Remittance Frequency</label>
      <app-dropdown-input
        formControlName="remittanceFrequencyTypeId"
        controlId="remittanceFrequencyTypeId"
        [dropdowns]="remittanceFrequencyDropdowns"
        [error]="formSubmitted && formGroup.controls.remittanceFrequencyTypeId.invalid" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.remittanceFrequencyTypeId.invalid"
        [customErrorMessages]="customErrorMessages.remittanceFrequencyTypeId"
        [errors]="formGroup.controls.remittanceFrequencyTypeId.errors" />
    </div>
  </div>
</div>
